import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SlDrawer, SlButton, SlIcon, SlInput, SlSelect, SlOption } from "@shoelace-style/shoelace/dist/react";
import ScrollContainer from "react-indiana-drag-scroll";
import { debounce } from "../../utils/Debounce";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import {languageOptions } from "../../utils/constants";
const languages = {
  "0": "All",
  "1": "Telugu",
  "2": "Tamil",
  "3": "Hindi",
  "4": "Kannada",
  "5": "Malayalam",
  "6": "Marathi",
  "7": "Bengali",
  "8": "Gujarati",
  "10": "Oria",
  "11": "English",
  "13": "Telugu-English"
}
function NewsPapers() {
  const [addNewsPaper, setAddNewsPaper] = useState(false);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [newsPapers, setNewsPapers] = useState([]);
  const [editData, setEditData] = useState();
  const [flag, setFlag] = useState(false);
  const [logoUrl, setLogoUrl] = useState();
  const [status, setStatus] = useState("all");
  const form1 = useForm();
  const watchBackgroundColor = form1.watch("background_color");
  const watchTextColor = form1.watch("text_color",'#ffffff');
  console.log(watchBackgroundColor, watchTextColor);
  const handleRequestClose = (event) => {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  };
  const handleClose = () => {
    setAddNewsPaper(false);
    form1.reset();
    setLogoUrl()
  };
  const handleSearch = (e) => {
    debounce(setSearch(e.target.value), 1000);
  };

  const fetchNewsPapers = async () => {
    try {
      setLoader(true);
      let res = await API({
        url: "/birdview/getNewspapers",
        method: "POST",
        responseType: "json",
        data: {
          search: search,
          status : status === "all" ? [1,0] : status === "0" ? [0] : [1],
        },
      });
      if (res.code === 200) {
        setLoader(false);
        setNewsPapers(res.data.result);
      } else {
        Toast("error", "Error in fetching news papers!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      let res = await API({
        url: "/birdview/updateNewspaperStatus",
        method: "POST",
        responseType: "json",
        data: {
          id: id,
          status: status === 0 ? 1 : 0,
        },
      });
      if (res.code === 200) {
        Toast("success", "News Paper Status Updated Successfully!");
        fetchNewsPapers();
      } else {
        Toast("error", "Error in updating news paper status!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const onSubmit = async (data) => {
    if(flag !== "edit"){
    try {
      let res = await API({
        url: "/birdview/addNewspaper",
        method: "POST",
        responseType: "json",
        data: {
          ...data,logo:logoUrl
        },
      });
      if (res.code === 200) {
        Toast("success", "News Paper added Successfully!");
        setAddNewsPaper(false);
        fetchNewsPapers();
        form1.reset();
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }
  else{
    try {
      let res = await API({
        url: "/birdview/editNewspaper",
        method: "POST",
        responseType: "json",
        data: {
          ...data,
          news_paper_id: editData.news_paper_id,
          logo:logoUrl || editData.logo,
          status:editData?.status
        },
      });
      if (res.code === 200) {
        Toast("success", "News Paper Edied Successfully!");
        setAddNewsPaper(false);
        fetchNewsPapers();
        form1.reset();
      } else {
        Toast("error", "Error in Editing news paper!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }
  setLogoUrl()
  setFlag()
}

  useEffect(() => {
    fetchNewsPapers();
  }, [search, status]);

  useEffect(() => {
    if(flag === "edit"){
      form1.setValue("newspaper_name", editData?.newspaper_name)
      form1.setValue("text_color", editData?.text_color)
      form1.setValue("background_color", editData?.background_color)
      form1.setValue("logo", editData?.logo)
      setLogoUrl(editData?.logo)
      form1.setValue("language", `${editData?.language}`)
    }
  }, [editData])
  
  const ImageUpload = async (formData) => {
      const res = await API({
        url: "/upload/svg",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.code === 200) {
        setLogoUrl(res.data);
        Toast("success", "Logo uploaded successfully");
      } else {
        Toast("error", "Error in uploading image");
      }
    
  };

  const handleImageChnage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].type === "image/svg+xml") {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("files", file);
        ImageUpload(formData);
      } else {
        form1.setValue("logo", "");
        Toast("error", "Please upload valid image");
      }
    }
    else {
      if (flag === "edit") {
        setLogoUrl(editData.data?.logo)
      }
      else{
        setLogoUrl("")
      }
  };
}

const handleStatus = (e) => {
  if (e.target.value === "all" ){
    setStatus("all")
  } else{
    setStatus(e.target.value)
  }
}

  return (
    <>
    <h4>News Papers</h4>
      <div className="d-flex justify-end mb-3 gap-2 items-end ml-auto flex-wrap">
        <SlSelect label="Status" size="small" value={status} onSlChange={handleStatus}>
          <SlOption value="all">All</SlOption>
          <SlOption value="1">Active</SlOption>
          <SlOption value="0">InActive</SlOption>
        </SlSelect>
        <SlInput
        label="Search News Papers"
          type="text"
          placeholder="Search News Papers"
          onSlInput={handleSearch}
          size="small"
        />
        <SlButton onClick={() => setAddNewsPaper(true)} variant="primary" size="small">
          Add News Paper
        </SlButton>
      </div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>S.No</th>
              <th>NewsPaper Name</th>
              <th>Logo</th>
              <th>Text Color</th>
              <th>BackGround Color</th>
              <th>Preview</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          {loader ? (
            <TableLoader colspan={8} />
          ) : newsPapers.length ? (
            <tbody>
              {newsPapers?.map((paper, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{paper.newspaper_name}-{languages[paper.language]}</td>
                  <td>
                    <img className="w-6" src={paper.logo} alt="logo" />
                  </td>
                  <td>
                    <div
                      className="w-6 h-4 rounded-full"
                      style={{ backgroundColor: paper.text_color }}
                    ></div>
                    {paper.text_color}
                  </td>
                  <td>
                    <div
                      className="w-6 h-4 rounded-full"
                      style={{ backgroundColor: paper.background_color }}
                    ></div>
                    {paper.background_color}
                  </td>
                  <td>
                    <div
                      className="h-6 w-9 text-xs px-2 py-1 rounded-xl"
                      style={{
                        backgroundColor: paper.background_color,
                        color: paper.text_color,
                      }}
                    >
                      100
                    </div>
                  </td>
                  <td>
                    <div
                      className="form-check form-switch"
                      style={{ marginLeft: "1rem" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={paper.status}
                        onChange={(e) => {
                          updateStatus(paper.news_paper_id, paper.status);
                        }}
                      />
                    </div>
                  </td>
                  <td>
                    <sl-tooltip content="Edit Newspaper">
                        <SlIcon library="lucide" className="cursor-pointer" name="pencil" onClick={() => {
                          setEditData(
                            paper
                          )
                          setFlag("edit")
                          setAddNewsPaper(true)
                        }}>

                        </SlIcon>
                    </sl-tooltip>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <NoDataFound colspan={8} />
          )}
        </table>
      </ScrollContainer>
      <SlDrawer
        open={addNewsPaper}
        onSlAfterHide={handleClose} 
        onSlRequestClose={handleRequestClose}
        label="Add News Paper"
      >
        <>
          <form onSubmit={form1.handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                NewsPaper Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder="Enter NewsPaper Name"
                {...form1.register("newspaper_name", { required: true })}
              />
              {form1.formState?.errors?.newspaper_name && (
                <span className="text-danger">
                  Please select NewsPaper Name
                </span>
              )}
            </div>
            <div className="mb-3">
                <label htmlFor="lang" className="form-label">Language</label>
                <select className="form-select" id="lang" {...form1.register("language", { required: true})}>
                  <option value="">Select Language</option>
                  <option value="0">All</option>
                    {languageOptions.map ((option) => (
                        <option value={option.value} key={option.value}>{option.label}</option>
                    ))}
                </select>
                {form1.formState?.errors?.language && (
                    <span className="text-danger">Please select language</span>
                )}
            </div>
            <div className="mb-3">
              <label htmlFor="logo-img" className="form-label">
                Logo (Only svg 24 * 24)
              </label>
              <input
                type="file"
                className="form-control"
                id="logo-img"
                accept="image/svg+xml"
                {...form1.register("logo", {  required: flag === "edit" ? false : true, onChange : (e) => handleImageChnage(e, "logo") })}
              />
              {logoUrl !== "" ? (
                    <p>{`${logoUrl ? logoUrl : ""}`}</p>
                  ) : (
                    flag === "edit" && <p>{`${editData.img_urls}`}</p>
                  )}
              {form1.formState?.errors?.logo && (
                <span className="text-danger">{"Please select logo"}</span>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="text_clr" className="form-label">
                Text Color
              </label>
              <input type="color" className="form-control" id="text_clr" {...form1.register("text_color", { required: true })} />
              {form1.formState?.errors?.text_color && (
                <span className="text-danger">{"Please select text color"}</span>
              )}
            </div>
            <div className="mb-3">
                <label htmlFor="background" className="form-label">BackGround Color</label>
                <input type="color" className="form-control" id="background" {...form1.register("background_color", { required: true })} />
                {form1.formState?.errors?.background_color && (
                  <span className="text-danger">Please select background color </span>
                )}
            </div>
            <div className="mb-3">
                <label htmlFor="status" className="form-label">Preview</label>
                <div className="d-flex gap-6">
                <div className="w-4 h-8" style={{backgroundColor: watchBackgroundColor}}></div>
                <div className="px-2 py-1 rounded-xl text-xs" style={{color: watchTextColor, backgroundColor:watchBackgroundColor, height:'24px'}}>4.12%</div>
                </div>
            </div>
            <button type="submit" className="btn btn-primary w-full">Submit</button> 
          </form>
        </>
      </SlDrawer>
    </>
  );
}

export default NewsPapers;
